export function readCachedUser() {
  try {
    const value = JSON.parse(localStorage.getItem("klang-user") || "{}");
    if (!value || typeof value !== "object" || typeof value.uid !== "string") return {};
    return {
      ...value,
      name: typeof value.name === "string" ? value.name : undefined,
      email: typeof value.email === "string" ? value.email : undefined,
      displayName: typeof value.displayName === "string" ? value.displayName : undefined,
    };
  } catch (_) { return {}; }
}
